import { LINKS_MENU_LOAD, LINKS_MENU_LOAD_SUCCESS, LINKS_MENU_LOAD_FAIL  } from "./actions";

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: [],
  extraData: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LINKS_MENU_LOAD:
      return {
        ...state,
        loading: true,
      };
    case LINKS_MENU_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: { l1Categories: action.result.megamenu },
        error: null,
        extraData: 'This is extra info..........',
      };
    case LINKS_MENU_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
}
